import { gql } from "@apollo/client";

export const GET_ALL_ENUMERATIONS = gql`
    query GetAllEnumerations($language: String = "de", $types: [Int!]!) {
        common_enumerations(
            where: { language: { _eq: $language }, type: { _in: $types } }
            order_by: { type: asc, key: asc }
        ) {
            id
            key
            label
            type
        }
    }
`;
